
export function PIDSvg({ pv, sp, cv, mode }: { pv: number, sp: number, cv: number, mode: string }) {
  return (
    <>
      <rect x="0" y="0" width="100" height="80" rx="8" fill="var(--color-surface-elevated)" stroke="var(--color-border-strong)" strokeWidth="3" />
      
      {/* Title */}
      <rect x="0" y="0" width="100" height="24" rx="8" fill="var(--color-primary)" />
      <text x="50" y="16" fill="#fff" fontSize="12" fontWeight="bold" textAnchor="middle">
        PID ({mode})
      </text>

      {/* Values */}
      <text x="10" y="40" fill="var(--color-text)" fontSize="10">SP: {sp.toFixed(1)}</text>
      <text x="10" y="55" fill="var(--color-text)" fontSize="10">PV: {pv.toFixed(1)}</text>
      <text x="10" y="70" fill="var(--color-text-secondary)" fontSize="10" fontWeight="bold">CV: {cv.toFixed(1)}</text>
    </>
  );
}
